import * as React from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import { Icon } from 'antd'
import Checkbox from 'web-makeup/dist/Checkbox'
import Popover from 'web-makeup/dist/Popover'
import Button from 'web-makeup/dist/Button'
import styled from 'styled-components'

import { ColumnsProps } from '../TableList'

const StyledIcon = styled(Icon)`
  &&&& {
    font-size: 0.875rem;
    color: #9b9b9b;
  }
`
const OptionsHolder = styled.div`
  .ant-checkbox-group-item {
    display: block;
  }
  max-height: 75vh;
  overflow-y: scroll;
`

interface Props {
  columns?: ColumnsProps[]
  options: any[]
  onChange?: (values: any[]) => void
  defaultValue?: any[]
  placeholder?: string
}

const CheckboxGroup = Checkbox.Group

const CheckboxPicker: React.SFC<Props & InjectedIntlProps> = ({
  options,
  defaultValue,
  onChange,
  placeholder,
  intl,
}) => (
  <Popover
    placement="bottom"
    content={
      <OptionsHolder>
        <CheckboxGroup options={options} defaultValue={defaultValue || []} onChange={onChange} />
      </OptionsHolder>
    }
    trigger="click"
  >
    <Button data-testid="popover-trigger">
      {placeholder || intl.formatMessage({ id: 'checkbox_picker_default_placeholder' })}{' '}
      <StyledIcon type="down" />
    </Button>
  </Popover>
)

export default injectIntl(CheckboxPicker)



// WEBPACK FOOTER //
// ./src/components/CheckboxPicker/CheckboxPicker.tsx